module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Patient profile')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Patient ID')) + ":"), _c('span', {
    staticStyle: {
      "margin-left": "36px"
    }
  }, [_vm._v("0000001")])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.profile.realname))])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Alias')) + ": ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    attrs: {
      "placeholder": _vm.alias
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Mobile')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.mobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Telephone')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.profile.telephone))])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Email')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.email))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298342e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-templates/patientProfile-carer.vue
// module id = 1440
// module chunks = 7